import React from 'react';
import { Typography } from '@material-ui/core';
import { formatNumber } from '../../../../utils';
import { getAnalyticLabel } from '../utils';
import CustomTooltip from '../../../BuildingBlocks/Tooltip/Tooltip';
import { RevenueTooltipProps } from '../types';

export default function RevenueChartTooltip({
  active,
  coordinate,
  payload,
  percentageMap,
}: RevenueTooltipProps) {
  if (!active) return null;
  const { name, value } = payload[0] || {};
  const percentage = percentageMap[name];
  const { x, y } = coordinate || {};
  return (
    <CustomTooltip
      arrow
      placement="top"
      open={true}
      title={
        <Typography>
          {getAnalyticLabel(name)}: {formatNumber(value)} (
          {percentage.toFixed(1)}%)
        </Typography>
      }
    >
      <div style={{ position: 'absolute', top: y, left: x }} />
    </CustomTooltip>
  );
}
